module.exports = __webpack_public_path__ + "sidebar-bg.6e05aa971ef2c7e31664.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/assets/img/sidebar-bg.jpg
// module id = ../../../../../src/assets/img/sidebar-bg.jpg
// module chunks = styles